const selectors = {
  block: "[data-fom]",
  trigger: "[data-fom-trigger]",
};

const initBlock = (block) => {
  const trigger = block.querySelector(selectors.trigger);

  trigger?.addEventListener("click", () => block.classList.add("active"));
};

document.addEventListener(
  "DOMContentLoaded",
  async function () {
    const blocks = document.querySelectorAll(selectors.block);

    blocks?.forEach(initBlock);
  },
  {
    once: true,
  }
);
